import { render, staticRenderFns } from "./GlobalHelpTab.vue?vue&type=template&id=f64b9d4a&"
import script from "./GlobalHelpTab.vue?vue&type=script&lang=js&"
export * from "./GlobalHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports